import React from 'react';
import { IconProps } from '.';

const SvgBulbFill = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} fillRule='evenodd' d='M8.25 16.068a8 8 0 1 1 7.5 0v3.682h-7.5v-3.682Z' clipRule='evenodd' />
      <path fill={color} d='M9 21h6a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2Z' />
    </svg>
  );
};

export default SvgBulbFill;
